const isEmbedded = () => window.self !== window.top;

export default isEmbedded;
